var map = {
	"./translations/i18n/es.json": [
		29922,
		"src_app_core_services_translate_translations_i18n_es_json"
	],
	"src/app/core/services/translate/translations/i18n/es.json": [
		29922,
		"src_app_core_services_translate_translations_i18n_es_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 84602;
module.exports = webpackAsyncContext;